module.exports = __webpack_public_path__ + "static/media/packsot.42fe0e7c.png";